export default __webpack_public_path__ + "_/images/app/android/android-ru-2-328a5930d1a0f5a2cf122c4c983ab9571012cf274dfc528ca4437c4799e65d2f.png";